jQuery(document).ready(function() {
	reBaseWorkItemImages();
});

function reBaseWorkItemImages() {
	jQuery('.work-item').each(function() {
		var profileImage = jQuery(this).find('img');

		profileImage.attr('srcset', '').attr('sizes', '');
		// var height = profileImage.height();
		// var width = profileImage.width();

		// profileImage.attr('thisHeight', height).attr('thisWidth', width);
	});
}


// WEBPACK FOOTER //
// ./assets/js/remove-size-attr-from-portfolio-pods.js